import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header bg-gradient-success py-7 py-lg-8 pt-lg-9" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-body text-center mb-7" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-xl-5 col-lg-6 col-md-8 px-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "Pantalla de bloqueo", -1)
const _hoisted_7 = { class: "text-lead text-white" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-bottom separator-skew zindex-100" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    x: "0",
    y: "0",
    viewBox: "0 0 2560 100",
    preserveAspectRatio: "none",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("polygon", {
      class: "fill-default",
      points: "2560 0 2560 100 0 100"
    })
  ])
], -1)
const _hoisted_9 = { class: "container mt--8 pb-5" }
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col-lg-5 col-md-7" }
const _hoisted_12 = { class: "card card-profile bg-secondary mt-5" }
const _hoisted_13 = { class: "row justify-content-center" }
const _hoisted_14 = { class: "col-lg-3 order-lg-2" }
const _hoisted_15 = { class: "card-profile-image" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "card-body pt-7 px-5" }
const _hoisted_18 = {
  key: 0,
  class: "pt-4 pm-1 px-5",
  style: {"animation-duration":"0.3s"}
}
const _hoisted_19 = { class: "text-center mb-4" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Unlock ")

import { Form } from "vee-validate";
import { useRouter } from "vue-router";
import { useSocket } from "@/plugins/socket";
import { AuthModule } from "@/store/modules/Auth";
import { AlertModule } from "@/store/modules/Alert";
import { computed, onMounted, ref, watch } from "vue";
import Notification from "@/components/Notification.vue";
import { IStatus, PauseModule } from "@/store/modules/Pause";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const socket = useSocket();
const router = useRouter();
const model = ref({
	password: "",
});
const reason = computed(() => PauseModule.reasonPause);
const user = computed(() => AuthModule.data.user);

watch(
	() => PauseModule.locked,
	(value, old) => {
		if (old && !value) {
			socket.client.emit("TICKET_LIST", { token: AuthModule.token });
			router.push({ path: "/omnichannel" });
		}
	}
);

onMounted(() => {
	PauseModule.setStatus(IStatus.CHATCENTER);
});

function onSubmit({ password }: { password: string }) {
	PauseModule.setLoading(true);
	socket.client.emit("SET_LISTO", { token: AuthModule.token, password });
}
const onClose = () => {
	AuthModule.resetError();
	AlertModule.shift();
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, "Usuario en pausa " + _toDisplayString(_unref(reason)) + ".", 1)
            ])
          ])
        ])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: _unref(user)?.picture,
                    class: "rounded-circle border-secondary"
                  }, null, 8, _hoisted_16)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_unref(AuthModule).error && _unref(AlertModule).error?.text)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(Notification, {
                          text: _unref(AlertModule).error?.text ?? '',
                          type: "danger",
                          icon: "fas fa-exclamation-triangle",
                          onClose: onClose
                        }, null, 8, ["text"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h3", null, _toDisplayString(_unref(user)?.name), 1)
              ]),
              _createVNode(_unref(Form), {
                role: "form",
                onSubmit: onSubmit
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_input, {
                    name: "password",
                    alternative: "",
                    "addon-left-icon": "ni ni-lock-circle-open",
                    type: "password",
                    placeholder: "Password",
                    modelValue: model.value.password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.password) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_base_button, {
                      class: "mt-2",
                      type: "primary",
                      "native-type": "submit",
                      loading: _unref(PauseModule).loading
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})